/**
 * https://openid.net/specs/openid-connect-basic-1_0.html#RequestParameters
 *
 * List of Query Params (Query Params accessed via document.location.search)
 * brand: string. controls the css theming
 * redirect_uri: string. required.
 * cancel_redirect_uri: string. The url is used to go back to the client's landing page when login/registration failed.
 * system: string. (optional) if specified, the logic checks for authorization in that system. If the consumer has auth, then redirect the end-user back to the redirection endpoint
 * cross_region: bool. (default = false). If true, it will not respect the redirect_uri. It redirects to the MyChart System that it authorized for.
 * mobile: boolean. Used for redirection. See CollectDemographics.tsx
 * instAct: string. Used by instant activation code. See CollectDemographics.tsx. Can be deprecated
 * correlationId: string.
 */
export enum OPENID_PARAMS {
    BRAND = 'brand',
    CLIENT_ID = 'client_id', // allows the client to override the PIP client ID
    REDIRECT_URI = 'redirect_uri',
    REDIRECT_URL = 'redirect_url', // deprecated. Used by mobile registration
    CANCEL_REDIRECT_URI = 'cancel_redirect_uri',
    EHR_SYSTEM = 'ehr_system',
    INSTANCE = 'instance',
    SYSTEM = 'system', // deprecated. use EHR_SYSTEM
    // Cross Region is for MyChart redirect flows. No other clients use cross_region=true.
    CROSS_REGION = 'cross_region',
    MOBILE = 'mobile', // mobile=true is a MyChart specific query parameter. You should use device_type for your use_case.
    INST_ACT = 'InstAct', // Used by AIA
    STATE = 'state',
    CORRELATION_ID = 'correlationId',
    LANG = 'lang',
    LOCATION_STATE = 'locationState',
    DISPLAY_MFA_FLOWS = 'display_mfa_flows',
    DEVICE_TYPE = 'device_type',
    CDP_DATA_B64 = 'cdpDataB64',
    AMPLITUDE_DEVICE_ID = 'amp_device_id', //Amplitude device Id generated and passed from Mychart. This param is required to stitch the cross domain amplitude events.
    AMPLITUDE_SESSION_ID = 'amp_session_id', //Amplitude session Id generated and passed from Mychart. This param is required to stitch the cross domain amplitude events.
    SDK_VERSION = 'sdk_version',
}

export enum AUTO_INSTANT_ACTIVATION_PARAMS {
    REGISTER_PHONE = 'register_phone', // This query parameter to show the phone validation page in the prove flow (Register).
    INSTANT_ACTIVATION_CODE = 'instant_activation_code',
    CANCEL_REDIRECT_URI = 'cancel_redirect_uri',
    REDIRECT_URI = 'redirect_uri',
    BRAND = 'brand',
    EHR_SYSTEM = 'ehr_system',
    IS_AIA_LINK_EXPIRED = 'is_aia_link_expired',
    IS_AUTHORIZED = 'is_authorized',
    EMAIL = 'aia_email',
    IS_NON_PATIENT_PROXY = 'is_non_patient_proxy',
}
